const selectors = {
  searchPage: '.template-search',
  searchResultsQa: '.search-page-results-count',
  searchRecommendationContainer: '.search-results-container',
  searchRecommendationItem: '.search-item',
  searchRecommendationItemTitle: '.cart-item__title',
  facets: '.facets__summary',
  facetsText: '.facets__summary-text',
  searchForm: '.search-input-main',
  menuPromoBanner: '.menu-promotion',
  menuPromoBannerTitle: '.menu-promotion-title',
  productToggle: '.product-page__toggle',
  toggleTitle: '.toggle__title',
  activeFacetsMobileContainer: '.active-facets-mobile',
  activeFacetsButton: '.active-facets__button',
  sortingSelect: '.collection-filters__sort',
  faqQuestion: '.toggle--faq',
  cartPage: '.template-cart',
  menuParent: '.header__bottom',
  menuMobileParent: '#site-menu-sidebar',
  logo: '.logo-img',
  breadcrumbs: '.breadcrumb',
  footer: '#shopify-section-footer',
  customerLoggedIn: '.customer-logged-in',
};

let lastClickedFacet = '';

/**
 * function to send event about cart leaves method
 *
 * @param {string} leaveby string with short description about way of leaving the page
 */
const handleCartLeave = (leaveby) => {
  window.dataLayer.push({ event: 'cart_page', event_parameter: 'click_exit', event_value: leaveby });
};

/**
 * function to send event about reading faq questions
 *
 * @param faq clicked faq toggle element
 */
const handleFaqClick = (faq) => {
  const parentOpen = faq.parentElement.classList.contains('opened');
  if (parentOpen) {
    const title = faq.textContent.trim();
    window.dataLayer.push({ event: 'faq', event_parameter: 'click', event_value: title });
  }
};

/**
 * function to send event about selected sorting option
 *
 * @param {event} ev click event
 */
const handleSorting = (ev) => {
  const selectedText = ev.target.options[ev.target.selectedIndex].text;
  if (selectedText) {
    window.dataLayer.push({ event: 'sort', event_parameter: 'select', event_value: selectedText });
  }
};

/**
 * function add listeners to facets and upgrade value on click
 */
const addEventListenerToFacets = () => {
  const facets = document.querySelectorAll(selectors.facets);
  facets.forEach((f) => {
    f.addEventListener('click', (e) => {
      if (e.target.classList.contains(selectors.facetsText.replace('.', ''))) {
        lastClickedFacet = e.target.textContent.trim();
      } else {
        lastClickedFacet = e.target.querySelector(selectors.facetsText)?.textContent.trim();
      }
    });
  });
};

/**
 * function to send event about clicked description on product page
 *
 * @param container click event
 */
const observeChangeFilters = (container) => {
  new MutationObserver(() => {
    const activeLabels = container.querySelectorAll(selectors.activeFacetsButton);
    let lastClickedOption = '';
    activeLabels.forEach((l) => {
      if (l.dataset?.filter && l.dataset?.value) {
        if (l.dataset.filter.trim() === lastClickedFacet) {
          lastClickedOption = l.dataset.value;
        }
      }
    });
    if (lastClickedFacet && lastClickedOption) window.dataLayer.push({ event: 'filter', event_parameter: lastClickedFacet, event_value: lastClickedOption });
    lastClickedOption = '';
    lastClickedFacet = '';
    addEventListenerToFacets();
  }).observe(container, {
    childList: true,
    subtree: true,
  });
};

/**
 * function to send event about clicked description on product page
 *
 * @param {event} ev click event
 */
const handleClickOnProductToggle = (ev) => {
  const parentOpen = ev.target.parentElement.classList.contains('opened');
  if (parentOpen) {
    const title = ev.target.textContent.trim();
    window.dataLayer.push({ event: 'product_page', event_parameter: 'click_description', event_value: title });
  }
};

/**
 * function to send event about clicked banners in menu
 *
 * @param {event} ev click event
 */
const handleClickOnMenuBanner = (ev) => {
  let title = null;
  let banner = null;

  if (ev.target.classList.contains(selectors.menuPromoBanner.replace('.', ''))) {
    banner = ev.target;
  } else {
    banner = ev.target.closest(selectors.menuPromoBanner);
  }

  if (!banner) return;
  title = banner.querySelector(`${selectors.menuPromoBannerTitle} span`);
  let value = title.textContent.trim();
  if (banner.id?.includes('menu')) value = `Menu layer - ${value}`;

  if (title) {
    window.dataLayer.push({ event: 'banner', event_parameter: 'click', event_value: value });
  }
};

/**
 * function to send event about clicked product in search result recommendations (dropdown)
 *
 * @param {event} ev click event
 */
const handleSearchRecommendationClick = (ev) => {
  let el = null;
  if (ev.target.classList.contains(selectors.searchRecommendationItem.replace('.', ''))) {
    el = ev.target;
  } else {
    el = ev.target.closest(selectors.searchRecommendationItem);
  }
  if (!el) return;
  window.dataLayer.push({ event: 'search', event_parameter: 'recommendation', event_value: el.querySelector(`${selectors.searchRecommendationItemTitle} span`)?.textContent.trim() });
};

/**
 * function to send event informations about the number of found products on search page
 *
 */
const emitSearchPageData = () => {
  const { count } = document.querySelector(selectors.searchResultsQa).dataset;
  if (count) {
    window.dataLayer.push({ event: 'search', event_parameter: 'nb_results', event_value: count });
  }
};

/**
 * function to send event about login action
 */
const handleLoginAndRegister = () => {
  if (window.location.hash === '#loginEv') {
    history.replaceState(null, null, ' ');
    window.dataLayer.push({ event: 'identification', event_parameter: 'login', event_value: 'login' });
  }

  if (window.location.hash === '#RegisterEv') {
    history.replaceState(null, null, ' ');
    if (document.body.classList.contains(selectors.customerLoggedIn.replace('.', ''))) window.dataLayer.push({ event: 'identification', event_parameter: 'account_creation', event_value: 'account_creation' });
  }
};

/** recognise which code should be called at start */
window.addEventListener('DOMContentLoaded', () => {
  window.dataLayer = window.dataLayer || [];
  const searchPage = document.querySelector(`body${selectors.searchPage}`);
  const cartPage = document.querySelector(`body${selectors.cartPage}`);
  const searchResultContainers = document.querySelectorAll(selectors.searchRecommendationContainer);
  const menuPromoBanners = document.querySelectorAll(selectors.menuPromoBanner);
  const productToogle = document.querySelectorAll(`${selectors.productToggle} ${selectors.toggleTitle}`);
  const filtersContainer = document.querySelector(selectors.activeFacetsMobileContainer);
  const sorting = document.querySelector(selectors.sortingSelect);
  const faqQuestions = document.querySelectorAll(`${selectors.faqQuestion} ${selectors.toggleTitle}`);

  if (faqQuestions) {
    faqQuestions.forEach((f) => {
      f.addEventListener('click', () => handleFaqClick(f));
    });
  }

  if (filtersContainer) {
    addEventListenerToFacets();
    observeChangeFilters(filtersContainer);
  }

  if (sorting) {
    sorting.addEventListener('change', (ev) => {
      lastClickedFacet = '';
      handleSorting(ev);
    });
  }

  if (searchPage) {
    emitSearchPageData();
  }

  if (cartPage) {
    const searchForms = document.querySelectorAll(selectors.searchForm);
    const logos = document.querySelectorAll(selectors.logo);
    const navigationLinks = document.querySelectorAll(`${selectors.menuParent} a`);
    const mobileNavigationLinks = document.querySelectorAll(`${selectors.menuMobileParent} a`);
    const breadcrumbs = document.querySelectorAll(`${selectors.breadcrumbs} a`);
    const footerNavigationLinks = document.querySelectorAll(`${selectors.footer} a`);

    searchForms?.forEach((s) => {
      s.addEventListener('submit', () => handleCartLeave('Search'));
    });
    breadcrumbs?.forEach((b) => {
      b.addEventListener('click', () => handleCartLeave('Breadcrumb'));
    });
    logos?.forEach((l) => {
      l.addEventListener('click', () => handleCartLeave('Logo'));
    });
    [...mobileNavigationLinks, ...navigationLinks, ...footerNavigationLinks]?.forEach((n) => {
      n.addEventListener('click', () => handleCartLeave('Menu'));
    });
  }

  handleLoginAndRegister();

  if (searchResultContainers) {
    searchResultContainers.forEach((c) => {
      c.addEventListener('click', (ev) => {
        handleSearchRecommendationClick(ev);
        if (cartPage) {
          handleCartLeave('Search');
        }
      });
    });
  }

  if (productToogle) {
    productToogle.forEach((d) => {
      d.addEventListener('click', (ev) => handleClickOnProductToggle(ev));
    });
  }

  if (menuPromoBanners) {
    menuPromoBanners.forEach((b) => {
      b.addEventListener('click', (ev) => handleClickOnMenuBanner(ev));
    });
  }

  document.addEventListener('click', (ev) => {
    const eventEmmitedHeadings = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];
    if (eventEmmitedHeadings.includes(ev.target.tagName)) {
      window.dataLayer.push({ event: 'subheader', event_parameter: 'click', event_value: ev.target.textContent.trim() });
    }
  });
});
